import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "_activity sub_page" }
const _hoisted_2 = { class: "sub_page_con wrap_1120" }
const _hoisted_3 = { class: "btn_wrap _default right_btn _board_type" }
const _hoisted_4 = { class: "list_table con_board sub_page_con_view suggestList" }
const _hoisted_5 = { class: "tr_div con_tit" }
const _hoisted_6 = { class: "tb_no no_768" }
const _hoisted_7 = { class: "tb_subject" }
const _hoisted_8 = { class: "tb_wr_name" }
const _hoisted_9 = { class: "tb_wr_name" }
const _hoisted_10 = { class: "tb_date_hour" }
const _hoisted_11 = {
  key: 1,
  class: "_flex _flex_100 _jc_sb"
}
const _hoisted_12 = { class: "_flex" }
const _hoisted_13 = { class: "tb_wr_name no_450" }
const _hoisted_14 = { class: "tb_wr_name" }
const _hoisted_15 = { class: "tb_date_hour" }
const _hoisted_16 = {
  key: 1,
  class: "tbody_li no_data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "sub_con_banner" }, [
          _createElementVNode("p", null, "참여하고 싶은 반성매매 활동을 제안해주세요!")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "common_btn w_130",
            style: {"margin-bottom":"15px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.loginConfirm && $setup.loginConfirm(...args)))
          }, "글쓰기")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", null, [
            _cache[9] || (_cache[9] = _createStaticVNode("<li class=\"thead_li\"><div class=\"tr_div con_tit\"><div class=\"tb_no\">번호</div><div class=\"tb_subject\">제목</div><div class=\"tb_wr_name\">조회수</div><div class=\"tb_wr_name\">작성자</div><div class=\"tb_date_hour\">작성일</div></div></li>", 1)),
            ($setup.state.list.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "tbody_li",
                    key: item.idx
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_router_link, {
                          to: { name: 'SuggestView', params: { id: item.idx } },
                          class: "elips_1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      (!$setup.state.isMobile)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_8, [
                              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mo_th" }, "조회수", -1)),
                              _createTextVNode(" " + _toDisplayString($setup.CommonUtils.numberFormat(item.viewCnt)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mo_th" }, "작성자", -1)),
                              _createTextVNode(" " + _toDisplayString(item.writer), 1)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mo_th" }, "날짜", -1)),
                              _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1)
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mo_th" }, "조회수", -1)),
                                _createTextVNode(" " + _toDisplayString($setup.CommonUtils.numberFormat(item.viewCnt)), 1)
                              ]),
                              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "divider no_450" }, "｜", -1)),
                              _createElementVNode("div", _hoisted_14, [
                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mo_th" }, "작성자", -1)),
                                _createTextVNode(" " + _toDisplayString(item.writer), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "mo_th" }, "날짜", -1)),
                              _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true)), 1)
                            ])
                          ]))
                    ])
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("li", _hoisted_16, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("div", { class: "tr_div" }, [
                    _createElementVNode("div", {
                      class: "tb_subject",
                      style: {"text-align":"center","width":"100%"}
                    }, "등록된 게시물이 없습니다.")
                  ], -1)
                ]))]))
          ])
        ]),
        ($setup.state.list.length !== 0)
          ? (_openBlock(), _createBlock(_component_PageBtn, {
              key: 0,
              currentPage: $setup.state.page,
              totalLength: $setup.state.totalLength,
              perPage: $setup.state.size,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}